"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../libs/utils");

var _context = require("./context");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _container = _interopRequireDefault(require("./styled/container"));

var _title = _interopRequireDefault(require("./styled/title"));

var _ul = _interopRequireDefault(require("./styled/ul"));
/**
 * Represents a section within a VerticalNavigation.
 * @category Layout
 */


var VerticalSection =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VerticalSection, _Component);

  function VerticalSection(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, VerticalSection);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VerticalSection).call(this, props));
    _this.entityHeaderId = (0, _utils.uniqueId)('entity-header');
    return _this;
  }

  (0, _createClass2["default"])(VerticalSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          style = _this$props.style,
          children = _this$props.children,
          className = _this$props.className;
      return _react["default"].createElement(_container["default"], {
        className: className,
        style: style
      }, _react["default"].createElement(_RenderIf["default"], {
        isTrue: !!label
      }, _react["default"].createElement(_title["default"], {
        id: this.entityHeaderId
      }, label)), _react["default"].createElement(_context.Provider, {
        value: this.entityHeaderId
      }, _react["default"].createElement(_ul["default"], null, children)));
    }
  }]);
  return VerticalSection;
}(_react.Component);

VerticalSection.propTypes = {
  /** The heading text for this section. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].node
};
VerticalSection.defaultProps = {
  label: null,
  className: undefined,
  style: undefined,
  children: null
};
var _default = VerticalSection;
exports["default"] = _default;